import PropTypes from 'prop-types';
import Link from '@activebrands/core-web/components/Link';
import { styled } from '@activebrands/core-web/libs/styletron';
import ThemeButton from 'components/buttons/ThemeButton';
import transformPreviewEditable from '@activebrands/core-web/libs/storyblok/utils/transform-preview-editable';

const List = styled('ul', {
    display: ['none', null, null, null, null, 'flex'],
    gap: '4px',
    flexDirection: 'row',
    marginLeft: 'auto',
});

const SecondaryMenuItem = styled('li', {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'var(--height-header)',
});

const SecondaryMenu = ({ items = [], buttonColor, resetNavigation = () => null }) => {
    if (!items?.length) {
        return null;
    }

    return (
        <List data-selector="global.nav.utility">
            {items.map(item => (
                <SecondaryMenuItem key={item.label} {...transformPreviewEditable(item._editable)}>
                    <ThemeButton
                        isVolatile
                        data-selector="global.nav.link"
                        theme="link"
                        $style={{
                            padding: '4px 8px',
                            color: buttonColor,
                            transitionDuration: null,
                        }}
                        fontKeys={['Miscellaneous/14_100_500']}
                        as={Link}
                        rel={item?.follow === 'no_follow' ? 'nofollow' : undefined}
                        to={item?.link?.url}
                        onClick={() => resetNavigation()}
                    >
                        {item.label}
                    </ThemeButton>
                </SecondaryMenuItem>
            ))}
        </List>
    );
};

SecondaryMenu.propTypes = {
    buttonColor: PropTypes.string,
    items: PropTypes.array.isRequired,
    resetNavigation: PropTypes.func,
};

export default SecondaryMenu;
